<p-selectButton
  [options]="calendarModeSelector"
  [(ngModel)]="selected"
  optionLabel="name"
  (onChange)="
    this.onAction({
      view: this.selected.code,
      retrieve: {
        appointments: true,
        notes: true
      }
    })
  "
/>
